// Team Insights — AI Music Advisor strings (prefix `ins.adv.`)
const en = {
  "ins.adv.advisorName": "Advisor",
  "ins.adv.newChat": "New chat",
  "ins.adv.newChatToast": "Started a new chat. Your earlier questions are still saved.",
  "ins.adv.historyKept": "Your earlier questions are still saved.",
  "ins.adv.showHistory": "Show history",
  "ins.adv.historyError": "We couldn't load your saved conversation.",
  "ins.adv.export": "Export",
  "ins.adv.exported": "Chat exported",
  "ins.adv.nothingToExport": "There's nothing to export yet.",
  "ins.adv.contactSupport": "Contact support",
  "ins.adv.chatRegion": "Advisor conversation",
  "ins.adv.sendFailed": "Your message couldn't be sent. Try again.",
  "ins.adv.notSent": "Not sent",
  "ins.adv.thinking": "Preparing an answer…",
  "ins.adv.suggestions": "Suggested questions",
  "ins.adv.inputLabel": "Your question",
  "ins.adv.placeholder": "Ask about releases, playlists, marketing or revenue…",
  "ins.adv.send": "Send",
  "ins.adv.disclaimer": "Answers are general guidance matched to your question's topic, combined with your catalog numbers. For account-specific issues, contact support.",
  "ins.adv.contextTitle": "What the advisor knows",
  "ins.adv.contextDesc": "Answers include your release count and genres from your catalog.",
  "ins.adv.releases": "Releases",
  "ins.adv.tracks": "Tracks",
  "ins.adv.plan": "Plan",
  "ins.adv.plan.free": "Free",
  "ins.adv.plan.artist": "Artist",
  "ins.adv.plan.label": "Label",
  "ins.adv.savedQuestions": "Saved questions",
  "ins.adv.managePlan": "Manage plan",
  "ins.adv.tip": "Mention a topic — marketing, playlists, revenue, production, distribution or career — to get the most relevant guidance.",
  "ins.adv.supportTitle": "Contact our support team",
  "ins.adv.supportDesc": "We'll open a ticket you can follow in Support. Replies will appear there.",
  "ins.adv.category": "Topic",
  "ins.adv.cat.technical": "Technical",
  "ins.adv.cat.account": "Account",
  "ins.adv.cat.release": "Release",
  "ins.adv.cat.payout": "Payout",
  "ins.adv.describe": "Describe the issue",
  "ins.adv.attachChat": "Include my last 5 advisor messages for context",
  "ins.adv.createTicket": "Create ticket",
  "ins.adv.ticketTooShort": "Please describe your issue in at least 10 characters.",
  "ins.adv.ticketTranscript": "Recent advisor conversation",
  "ins.adv.ticketSubject": "Support request from the Music Advisor",
  "ins.adv.ticketCreated": "Support ticket created. Our team will reply in Support.",
  "ins.adv.viewTicket": "View ticket",
  "ins.adv.ticketFailed": "We couldn't create the ticket. Please try again.",
};

const tr = {
  "ins.adv.advisorName": "Danışman",
  "ins.adv.newChat": "Yeni sohbet",
  "ins.adv.newChatToast": "Yeni bir sohbet başlatıldı. Önceki sorularınız kayıtlı kalmaya devam ediyor.",
  "ins.adv.historyKept": "Önceki sorularınız hâlâ kayıtlı.",
  "ins.adv.showHistory": "Geçmişi göster",
  "ins.adv.historyError": "Kayıtlı sohbetiniz yüklenemedi.",
  "ins.adv.export": "Dışa aktar",
  "ins.adv.exported": "Sohbet dışa aktarıldı",
  "ins.adv.nothingToExport": "Henüz dışa aktarılacak bir şey yok.",
  "ins.adv.contactSupport": "Destekle iletişime geç",
  "ins.adv.chatRegion": "Danışman sohbeti",
  "ins.adv.sendFailed": "Mesajınız gönderilemedi. Tekrar deneyin.",
  "ins.adv.notSent": "Gönderilmedi",
  "ins.adv.thinking": "Yanıt hazırlanıyor…",
  "ins.adv.suggestions": "Önerilen sorular",
  "ins.adv.inputLabel": "Sorunuz",
  "ins.adv.placeholder": "Yayınlar, playlist'ler, pazarlama veya gelir hakkında sorun…",
  "ins.adv.send": "Gönder",
  "ins.adv.disclaimer": "Yanıtlar, sorunuzun konusuna göre seçilen genel tavsiyelerdir ve katalog verilerinizle birleştirilir. Hesabınıza özel sorunlar için destekle iletişime geçin.",
  "ins.adv.contextTitle": "Danışmanın bildikleri",
  "ins.adv.contextDesc": "Yanıtlar, kataloğunuzdaki yayın sayısını ve türleri içerir.",
  "ins.adv.releases": "Yayınlar",
  "ins.adv.tracks": "Parçalar",
  "ins.adv.plan": "Plan",
  "ins.adv.plan.free": "Ücretsiz",
  "ins.adv.plan.artist": "Sanatçı",
  "ins.adv.plan.label": "Plak Şirketi",
  "ins.adv.savedQuestions": "Kayıtlı sorular",
  "ins.adv.managePlan": "Planı yönet",
  "ins.adv.tip": "En uygun tavsiyeyi almak için bir konu belirtin: pazarlama, playlist, gelir, prodüksiyon, dağıtım veya kariyer.",
  "ins.adv.supportTitle": "Destek ekibimizle iletişime geçin",
  "ins.adv.supportDesc": "Destek sayfasından takip edebileceğiniz bir talep oluşturacağız. Yanıtlar orada görünür.",
  "ins.adv.category": "Konu",
  "ins.adv.cat.technical": "Teknik",
  "ins.adv.cat.account": "Hesap",
  "ins.adv.cat.release": "Yayın",
  "ins.adv.cat.payout": "Ödeme",
  "ins.adv.describe": "Sorunu açıklayın",
  "ins.adv.attachChat": "Bağlam için son 5 danışman mesajımı ekle",
  "ins.adv.createTicket": "Talep oluştur",
  "ins.adv.ticketTooShort": "Lütfen sorununuzu en az 10 karakterle açıklayın.",
  "ins.adv.ticketTranscript": "Son danışman sohbeti",
  "ins.adv.ticketSubject": "Müzik Danışmanı üzerinden destek talebi",
  "ins.adv.ticketCreated": "Destek talebi oluşturuldu. Ekibimiz Destek sayfasından yanıt verecek.",
  "ins.adv.viewTicket": "Talebi görüntüle",
  "ins.adv.ticketFailed": "Talep oluşturulamadı. Lütfen tekrar deneyin.",
};

const es = {
  "ins.adv.advisorName": "Asesor",
  "ins.adv.newChat": "Nuevo chat",
  "ins.adv.newChatToast": "Nuevo chat iniciado. Tus preguntas anteriores siguen guardadas.",
  "ins.adv.historyKept": "Tus preguntas anteriores siguen guardadas.",
  "ins.adv.showHistory": "Ver historial",
  "ins.adv.historyError": "No pudimos cargar tu conversación guardada.",
  "ins.adv.export": "Exportar",
  "ins.adv.exported": "Chat exportado",
  "ins.adv.nothingToExport": "Todavía no hay nada que exportar.",
  "ins.adv.contactSupport": "Contactar con soporte",
  "ins.adv.chatRegion": "Conversación con el asesor",
  "ins.adv.sendFailed": "No se pudo enviar tu mensaje. Inténtalo de nuevo.",
  "ins.adv.notSent": "No enviado",
  "ins.adv.thinking": "Preparando una respuesta…",
  "ins.adv.suggestions": "Preguntas sugeridas",
  "ins.adv.inputLabel": "Tu pregunta",
  "ins.adv.placeholder": "Pregunta sobre lanzamientos, playlists, marketing o ingresos…",
  "ins.adv.send": "Enviar",
  "ins.adv.disclaimer": "Las respuestas son orientaciones generales elegidas según el tema de tu pregunta y combinadas con los datos de tu catálogo. Para problemas de tu cuenta, contacta con soporte.",
  "ins.adv.contextTitle": "Lo que sabe el asesor",
  "ins.adv.contextDesc": "Las respuestas incluyen tu número de lanzamientos y los géneros de tu catálogo.",
  "ins.adv.releases": "Lanzamientos",
  "ins.adv.tracks": "Pistas",
  "ins.adv.plan": "Plan",
  "ins.adv.plan.free": "Gratis",
  "ins.adv.plan.artist": "Artista",
  "ins.adv.plan.label": "Sello",
  "ins.adv.savedQuestions": "Preguntas guardadas",
  "ins.adv.managePlan": "Gestionar plan",
  "ins.adv.tip": "Menciona un tema (marketing, playlists, ingresos, producción, distribución o carrera) para obtener la orientación más relevante.",
  "ins.adv.supportTitle": "Contacta con nuestro equipo de soporte",
  "ins.adv.supportDesc": "Abriremos un ticket que podrás seguir en Soporte. Las respuestas aparecerán allí.",
  "ins.adv.category": "Tema",
  "ins.adv.cat.technical": "Técnico",
  "ins.adv.cat.account": "Cuenta",
  "ins.adv.cat.release": "Lanzamiento",
  "ins.adv.cat.payout": "Pagos",
  "ins.adv.describe": "Describe el problema",
  "ins.adv.attachChat": "Incluir mis últimos 5 mensajes con el asesor como contexto",
  "ins.adv.createTicket": "Crear ticket",
  "ins.adv.ticketTooShort": "Describe tu problema con al menos 10 caracteres.",
  "ins.adv.ticketTranscript": "Conversación reciente con el asesor",
  "ins.adv.ticketSubject": "Solicitud de soporte desde el Asesor Musical",
  "ins.adv.ticketCreated": "Ticket de soporte creado. Nuestro equipo responderá en Soporte.",
  "ins.adv.viewTicket": "Ver ticket",
  "ins.adv.ticketFailed": "No pudimos crear el ticket. Inténtalo de nuevo.",
};

export default { en, tr, es };
